// GENERATED by tools/scripts/generate-icons.mjs from libs/icons/svg/outline/banknotes.svg. Do not edit.

import { glyph } from '@gto/icons/glyphs/outline/banknotes'

import { Icon, type IconComponentProps } from '../icon'

export const BanknotesIcon = (props: IconComponentProps) => (
  <Icon
    glyph={glyph}
    {...props}
  />
)
